
import { setLocale } from 'yup';

setLocale({
  mixed: {
    default: 'validation_invalid',
    required: 'validation_required',
  },
  string: {
    email: 'validation_string_email',
    min: ({ min }) => ({ key: 'validation_string_min', values: { min } }),
    max: ({ max }) => ({ key: 'validation_string_max', values: { max } }),
    length: ({ length }) => ({ key: 'validation_string_length', values: { length } }),
    url: 'validation_url'
  },
  number: {
    integer: 'validation_integer',
    positive: 'validation_number_positive',
    negative: 'validation_number_negative',
    min: ({ min }) => ({ key: 'validation_number_min', values: { min } }),
    max: ({ max }) => ({ key: 'validation_number_max', values: { max } }),
    moreThan: ({ more }) => ({ key: 'validation_string_min', values: { min: more } }),
    lessThan: ({ less }) => ({ key: 'validation_string_max', values: { max: less } }),
  },
  array: {
    max: ({ max }) => ({ key: 'validation_array_max', values: { count: max } }),
    min: ({ min }) => ({ key: 'validation_array_min', values: { count: min } }),
  }
});
